import {
  DiscussionContext,
  DiscussionContextType,
  Message,
  QUERY_KEYS,
} from "@cnx/common";
import dayjs from "dayjs";
import DateFormat from "types/DateFormat";

export const getDraftTitle = (ctx: DiscussionContext | undefined): string => {
  if (!ctx) return "";
  switch (ctx.context) {
    case DiscussionContextType.STOP:
    case DiscussionContextType.RESOURCE_COMBINATION:
      return ctx.tripId ?? "";
    case DiscussionContextType.ADDRESS:
      return ctx.locationName ?? "";
    case DiscussionContextType.SALES_ORDER_LEG:
      return ctx.bookingId ?? "";
    default:
      return "";
  }
};

export const formatChatTime = (dateString: string) => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  return dayjs(date).format(DateFormat.ONLY_TIME);
};

const mapDiscussionContextTypeToQueryKey = {
  [DiscussionContextType.RESOURCE_COMBINATION]: [
    [QUERY_KEYS.SHIPMENT],
    [QUERY_KEYS.SHIPMENTS],
    [QUERY_KEYS.ALL_EXCEPTIONS],
  ],
  [DiscussionContextType.STOP]: [
    [QUERY_KEYS.STOP],
    [QUERY_KEYS.STOPS],
    [QUERY_KEYS.TERMINAL_STOPS],
    [QUERY_KEYS.ALL_EXCEPTIONS],
  ],
  [DiscussionContextType.ADDRESS]: [
    [QUERY_KEYS.STOP],
    [QUERY_KEYS.STOPS],
    [QUERY_KEYS.TERMINAL_STOPS],
    [QUERY_KEYS.ALL_EXCEPTIONS],
  ],
  [DiscussionContextType.SALES_ORDER_LEG]: [
    [QUERY_KEYS.ACTIVITY],
    [QUERY_KEYS.ACTIVITIES],
    [QUERY_KEYS.TERMINAL_ACTIVITIES],
    [QUERY_KEYS.ALL_EXCEPTIONS],
  ],
};

export const getQueryKeysForDiscussionContext = (
  context: DiscussionContextType
) => {
  if (!Object.hasOwn(mapDiscussionContextTypeToQueryKey, context))
    return undefined;
  return mapDiscussionContextTypeToQueryKey[context];
};

export const groupMessagesByDate = (messages: Message[]) =>
  messages.reduce<{ date: string; items: Message[] }[]>((acc, message) => {
    if (!message.createdTime) {
      return acc;
    }
    const dateKey = dayjs(new Date(message.createdTime ?? "")).format(
      DateFormat.ONLY_DATE
    );

    const lastGroup = acc[acc.length - 1];
    if (lastGroup && lastGroup.date === dateKey) {
      lastGroup.items.push(message);
      return acc;
    }

    acc.push({ date: dateKey, items: [message] });
    return acc;
  }, []);
